import { render, staticRenderFns } from "./PostView.vue?vue&type=template&id=f8a2fb12"
import script from "./PostView.vue?vue&type=script&lang=js"
export * from "./PostView.vue?vue&type=script&lang=js"
import style0 from "./PostView.vue?vue&type=style&index=0&id=f8a2fb12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports